angular.module('FlexyBeautyApp.services')
    .factory('KycDocumentType', ['gettextCatalog', function (gettextCatalog) {
        return {
            ARTICLES_OF_ASSOCIATION: {
                id: "articlesOfAssociation",
                label: gettextCatalog.getString("Une copie des statuts de l'entreprise")
            },
            IDENTITY_PROOF: {
                id: "identityProof",
                label: gettextCatalog.getString("Pièce d’identité, passeport ou permis de conduire de l’ensemble des bénéficiaires.")
            },
            REGISTRATION_PROOF: {
                id: "registrationProof",
                label: gettextCatalog.getString("K-bis de moins de 3 mois ou (document INSEE si non enregistré au registre du Commerce)."),
                link : "https://www.infogreffe.fr/documents-officiels/demande-kbis.html"
            }
        };
    }]);



// WEBPACK FOOTER //
// ./js/services/views/KycDocumentType.js